import { useLanguage } from 'contexts/LanguageContext';
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <h1 className="text-4xl font-bold text-white mb-4">404</h1>
      <p className="text-gray-400 mb-6">{t('common.page.notFound')}</p>
      <Link to="/" className="text-primary-400 hover:text-primary-300">
        {t('common.page.returnToDashboard')}
      </Link>
    </div>
  );
};

export default NotFound; 